import React, { useState, useEffect } from 'react'
import Cookies from 'universal-cookie'

const Efiling = () => {
  const [selectedCategory, setSelectedCategory] = useState("CDCID");
  const [searchTerm, setSearchTerm] = useState("");
  const [efilingData, setEfilingData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [limit] = useState(10);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const [isAddMode, setIsAddMode] = useState(false);
  const [caseIdInput, setCaseIdInput] = useState("");
 const [formData, setFormData] = useState({
  documentType: "",
  subject: "",
  remarks: "",
  email: "", // ✅ for filing by
});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);
  const [detailData, setDetailData] = useState(null);
  const [activeTab, setActiveTab] = useState("E-Filing");

  const cookies = new Cookies();
  const categories = ["CDCID", "Title"];

  const token = cookies.get("authToken");

  const fetchEfilingData = async (page = 1, searchValue = '') => {
    setLoading(true)
    try {
      // Build URL with search parameter if provided, otherwise get all
      let url = `https://clevdoc-legal-cms-b25ce73f594e.herokuapp.com/efiling/getAll?page=${page}&limit=${limit}`
      
      if (searchValue && searchValue.trim() !== '') {
        url += `&cd_Case_ID=${searchValue}`
      }
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'module-id': 'efilling'
        }
      })

      if (response.ok) {
        const result = await response.json()
        setEfilingData(result.data || [])
        setTotalRecords(result.total || 0)
        setCurrentPage(page)
      } else {
        console.error('Error fetching data:', response.statusText)
      }
    } catch (error) {
      console.error('Error:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleServeCopy = async () => {
  const caseId = selectedRecord?.cd_Case_ID;

  if (!caseId) {
    alert("Case ID missing");
    return;
  }
  if (!formData.email) {
  alert("Please select Filing By");
  return;
}

  if (!formData.documentType) {
    alert("Document Type is required");
    return;
  }

  if (selectedFiles.length === 0) {
    alert("Please upload at least one document");
    return;
  }

  try {
    setIsSubmitting(true);

    const formDataObj = new FormData();

    selectedFiles.forEach((file) => {
      formDataObj.append("file", file);
    });

    formDataObj.append("document_type", formData.documentType);
    formDataObj.append("subject", formData.subject);
    formDataObj.append("remarks", formData.remarks);
    formDataObj.append("cd_Case_ID", selectedRecord.cd_Case_ID);
    formDataObj.append("email", formData.email);

    const response = await fetch(
      "https://clevdoc-legal-cms-b25ce73f594e.herokuapp.com/efiling/efiling",
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "module-id": "efiling",
        },
        body: formDataObj,
      }
    );

    const result = await response.json();

    if (!response.ok) {
      alert(result.message || "Serve Failed ❌");
      return;
    }

    // ✅ IMPORTANT: Use returned data
    const newEfiling = result.efiling;
    const updatedCommence = result.commenceDetails;

    // Update selected record so attachments refresh instantly
    setSelectedRecord(newEfiling);

    // Optional: If detail modal is open update it
    setDetailData({
      efiling: newEfiling,
      commenceDetails: updatedCommence,
    });

    alert("Served Successfully ✅");

    // Reset
    setSelectedFiles([]);
   setFormData({
  documentType: "",
  subject: "",
  remarks: "",
  email: "", // ✅ include this
});

    setShowEditModal(false);

    // Refresh list
    fetchEfilingData(currentPage, searchTerm);

  } catch (error) {
    console.error("Serve Error:", error);
    alert("Something went wrong");
  } finally {
    setIsSubmitting(false);
  }
};

const getFilingOptions = () => {
  if (!selectedRecord?.sendTo) return [];

  const { claimant_names, respondent_names, arbitrator_names } =
    selectedRecord.sendTo;

  const formatOptions = (arr, role) =>
    arr?.map((person) => ({
      label: `${person.name} (${role})`,
      value: person.email,
    })) || [];

  return [
    ...formatOptions(claimant_names, "Claimant"),
    ...formatOptions(respondent_names, "Respondent"),
    ...formatOptions(arbitrator_names, "Arbitrator"),
  ];
};

  useEffect(() => {
    const trimmed = searchTerm.trim();

    const timer = setTimeout(() => {
      fetchEfilingData(1, trimmed);
      setCurrentPage(1);
    }, 500);

  return () => clearTimeout(timer);
}, [searchTerm]);

  const handleCaseSearch = async () => {
    if (!caseIdInput) {
      alert("Enter Case ID");
      return;
    }

    try {
      const response = await fetch(
        `https://clevdoc-legal-cms-b25ce73f594e.herokuapp.com/efiling/getAll?page=1&limit=100&cd_Case_ID=${caseIdInput}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "module-id": "efiling",
          },
        },
      );

      const result = await response.json();

      if (!response.ok || !result.data || result.data.length === 0) {
        alert("Case not found");
        return;
      }

      // 🔥 THIS IS REAL RECORD FROM BACKEND - POPULATE SAME AS EDIT
      const fetchedRecord = result.data[0];
      setSelectedRecord(fetchedRecord);

      // Populate form data same as Edit button
      setFormData({
        documentType: fetchedRecord.document_type?.replace(/`/g, "") || "",
        subject: fetchedRecord.subject?.replace(/`/g, "") || "",
        remarks:
          fetchedRecord.remarks?.replace(/<[^>]*>/g, "")?.replace(/`/g, "") ||
          "",
           email: "",
      });
      setSelectedFiles([]);
    } catch (error) {
      console.error(error);
      alert("Error searching case");
    }
  };

  const handlePageChange = (page) => {
    fetchEfilingData(page, searchTerm);
  };

  const handleEdit = async (record) => {
    setDetailLoading(true);
    try {
      const response = await fetch(
        `https://clevdoc-legal-cms-b25ce73f594e.herokuapp.com/efiling/getById/${record._id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "module-id": "efiling",
          },
        },
      );

      if (response.ok) {
        const result = await response.json();
        setDetailData(result.data);
        setShowDetailModal(true);
      } else {
        alert("Failed to load case details");
      }
    } catch (error) {
      console.error("Error fetching case details:", error);
      alert("Error loading case details");
    } finally {
      setDetailLoading(false);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-IN");
  };

  const getClaimantNames = (claimants) => {
    return claimants?.map((c) => c.name).join(", ") || "-";
  };

  const getRespondentNames = (respondents) => {
    return respondents?.map((r) => r.name).join(", ") || "-";
  };

  const getArbitratorNames = (arbitrators) => {
    return arbitrators?.map((a) => a.name).join(", ") || "-";
  };

  const totalPages = Math.ceil(totalRecords / limit);
  const hasNextPage = currentPage < totalPages;

  return (
    <div className="w-full mt-14 md:mt-28 md:w-[calc(100%-250px)] lg:w-[calc(100%-250px)] ml-0 md:ml-[250px] lg:ml-[250px] p-3 md:p-4 lg:p-5 bg-gray-50 min-h-screen">
      {/* Title */}
      <h1 className="text-xl md:text-2xl lg:text-4xl font-semibold text-black mb-5 md:mb-6 lg:mb-8 px-0 md:px-1 lg:px-2">
        E-Filing
      </h1>

      {/* Search Section */}
      <div className="bg-white p-4 md:p-5 lg:p-6 rounded-lg shadow-sm mb-6">
        <div className="flex flex-col md:flex-row gap-3 md:gap-3 lg:gap-4 items-stretch md:items-center flex-wrap">
          {/* Dropdown Category */}
          <div className="relative flex-1 md:flex-none md:w-[250px] lg:w-[300px] min-w-[180px] md:min-w-[200px]">
            <select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              className="w-full px-3 md:px-4 py-2 md:py-3 border-2 border-blue-300 rounded-lg text-sm md:text-base text-black bg-white cursor-pointer appearance-none transition-all duration-300 hover:border-blue-400 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 z-10"
              style={{
                backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e")`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 10px center",
                backgroundSize: "20px",
                paddingRight: "35px",
              }}
            >
              {categories.map((category) => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </select>
          </div>

          {/* Search Input */}
          <input
            type="text"
            placeholder="Search here"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="flex-1 min-w-[200px] px-3 md:px-4 py-2 md:py-3 border-2 border-gray-300 rounded-lg text-sm md:text-base text-black bg-white transition-all duration-300 placeholder-gray-400 hover:border-gray-400 focus:outline-none focus:border-blue-500 focus:bg-white focus:ring-2 focus:ring-blue-100"
          />

          {/* Search Button */}
          <button
            // onClick={handleSearch}
            disabled={loading}
            className="w-full md:w-auto md:flex-none px-6 md:px-8 py-2 md:py-3 bg-[#001f4d] text-white border-none rounded-lg text-sm md:text-base font-semibold cursor-pointer transition-all duration-300 hover:bg-[#00142e] hover:shadow-lg active:bg-[#001f4d] active:scale-95 whitespace-nowrap z-10 min-w-[100px] disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? "Loading..." : "Search"}
          </button>
        </div>
      </div>

      {/* {ADD efilling button } */}
      <div className="bg-white p-4 md:p-5 lg:p-6 rounded-lg shadow-sm mb-6">
        <button
          onClick={() => {
            setIsAddMode(true);
            setSelectedRecord(null);
            setFormData({
              documentType: "",
              subject: "",
              remarks: "",
               email: "",
            });
            setSelectedFiles([]);
            setCaseIdInput("");
            setShowEditModal(true);
          }}
          className="px-6 py-2 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors"
        >
          +E-Filing
        </button>
      </div>

      {/* Table Section */}
      <div className="bg-white rounded-lg shadow-sm overflow-hidden">
        {loading && !efilingData.length ? (
          <div className="p-8 text-center text-gray-500">Loading...</div>
        ) : efilingData.length === 0 ? (
          <div className="p-8 text-center text-gray-500">No records found</div>
        ) : (
          <>
            <div className="overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-100 border-b border-gray-200">
                    <th className="px-4 py-3 text-left text-sm font-semibold text-black">
                      S.No
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-black">
                      Case ID
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-black">
                      Document Type
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-black">
                      Subject
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-black">
                      Filed By
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-black">
                      Claimant
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-black">
                      Respondent
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-black">
                      Arbitrator
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-black">
                      Attachments
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-black">
                      Filing Date
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-black">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {efilingData.map((item, index) => (
                    <tr
                      key={item._id}
                      className="border-b border-gray-200 hover:bg-gray-50 transition-colors"
                    >
                      <td className="px-4 py-3 text-sm text-black">
                        {(currentPage - 1) * limit + index + 1}
                      </td>
                      <td className="px-4 py-3 text-sm text-black font-medium">
                        {item.cd_Case_ID}
                      </td>
                      <td className="px-4 py-3 text-sm text-black">
                        {item.document_type?.replace(/`/g, "") || "-"}
                      </td>
                      <td className="px-4 py-3 text-sm text-black max-w-xs truncate">
                        {item.subject?.replace(/`/g, "") || "-"}
                      </td>
                      <td className="px-4 py-3 text-sm text-black">
                        {item.user
                          ? `${item.user.first_name} ${item.user.last_name}`
                          : "-"}
                      </td>
                      <td className="px-4 py-3 text-sm text-black max-w-xs truncate">
                        {getClaimantNames(item.sendTo?.claimant_names)}
                      </td>
                      <td className="px-4 py-3 text-sm text-black max-w-xs truncate">
                        {getRespondentNames(item.sendTo?.respondent_names)}
                      </td>
                      <td className="px-4 py-3 text-sm text-black max-w-xs truncate">
                        {getArbitratorNames(item.sendTo?.arbitrator_names)}
                      </td>
                      <td className="px-4 py-3 text-sm text-center">
                        {item.serve_Document?.length > 0 ? (
                          <span className="inline-flex items-center justify-center w-6 h-6 bg-blue-100 text-blue-600 rounded-full text-xs font-semibold cursor-pointer hover:bg-blue-200">
                            {item.serve_Document.length}
                          </span>
                        ) : (
                          <span className="text-gray-400">-</span>
                        )}
                      </td>
                      <td className="px-4 py-3 text-sm text-black">
                        {formatDate(item.created_at)}
                      </td>
                      <td className="px-4 py-3 text-sm">
                        <button
                          onClick={() => handleEdit(item)}
                          className="px-3 py-1 bg-blue-500 text-white rounded text-xs font-medium hover:bg-blue-600 transition-colors"
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="px-4 py-4 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4">
              <div className="text-sm text-gray-600">
                Showing {efilingData.length} of {totalRecords} records (Page{" "}
                {currentPage} of {totalPages})
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="px-3 py-1 border border-gray-300 rounded text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  Previous
                </button>
                <span className="px-3 py-1 text-sm font-medium text-gray-700 bg-gray-100 rounded">
                  {currentPage}
                </span>
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={!hasNextPage}
                  className="px-3 py-1 border border-gray-300 rounded text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  Next
                </button>
              </div>
            </div>
          </>
        )}
      </div>

      {/* Edit Modal */}
      {showEditModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg shadow-lg max-w-3xl w-full max-h-[90vh] overflow-y-auto">
            {/* Modal Header */}
            <div className="sticky top-0 bg-white border-b border-gray-200 p-6 flex justify-between items-center">
              <h1 className="text-2xl font-bold text-black">
                {isAddMode ? "Add New E-Filing" : "Edit E-Filing"}
              </h1>
              <button
                onClick={() => setShowEditModal(false)}
                className="text-gray-600 hover:text-gray-800 text-2xl"
              >
                ✕
              </button>
            </div>

            {isAddMode && (
              <div className="p-6 border-b border-gray-200 bg-gray-50">
                <label className="block text-sm font-semibold mb-2">
                  Search Case ID <span className="text-red-500">*</span>
                </label>

                <div className="flex gap-3">
                  <input
                    type="text"
                    value={caseIdInput}
                    onChange={(e) => setCaseIdInput(e.target.value)}
                    className="flex-1 px-4 py-2 border-2 border-gray-300 rounded-lg"
                    placeholder="Enter Case ID"
                    disabled={selectedRecord !== null}
                  />

                  <button
                    onClick={handleCaseSearch}
                    className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                    disabled={selectedRecord !== null}
                  >
                    Search
                  </button>

                  {selectedRecord && (
                    <div className="px-4 py-2 bg-white rounded-lg border-2 border-green-300 flex items-center">
                      <span className="text-green-600 font-semibold">
                        ✓ {caseIdInput}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Modal Content */}
            <div className="p-6 space-y-6">
              {/* Document Type and Subject */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {selectedRecord && (
  <div>
    <label className="block text-sm font-semibold text-black mb-2">
      <span className="text-red-500">*</span> Filing By
    </label>

    <select
      value={formData.email}
      onChange={(e) =>
        setFormData({ ...formData, email: e.target.value })
      }
      className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg"
    >
      <option value="">Select Filing Person</option>

      {getFilingOptions().map((option, index) => (
        <option key={index} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </div>
)}
                {/* Document Type Dropdown */}

                <div>
                  <label className="block text-sm font-semibold text-black mb-2">
                    <span className="text-red-500">*</span> Document Type
                  </label>
                  <select
                    value={formData.documentType}
                    onChange={(e) =>
                      setFormData({ ...formData, documentType: e.target.value })
                    }
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg text-gray-700 bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 cursor-pointer appearance-none"
                    style={{
                      backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e")`,
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "right 10px center",
                      backgroundSize: "20px",
                      paddingRight: "35px",
                    }}
                  >
                    <option value="">Select</option>
                    <option value="Petition">Petition</option>
                    <option value="Vakalatnama">Vakalatnama</option>
                    <option value="Affidavit">Affidavit</option>
                    <option value="Other Documents">Other Documents</option>
                  </select>
                </div>

                {/* Subject */}
                <div>
                  <label className="block text-sm font-semibold text-black mb-2">
                    Subject
                  </label>
                  <input
                    type="text"
                    value={formData.subject}
                    onChange={(e) =>
                      setFormData({ ...formData, subject: e.target.value })
                    }
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg text-black bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                  />
                </div>
              </div>

              {/* To Field */}
              {selectedRecord && (
                <div>
                  <label className="block text-sm font-semibold text-black mb-2">
                    To:
                  </label>
                  <div className="px-4 py-3 border-2 border-gray-300 rounded-lg bg-white">
                    <p className="text-black">
                      {[
                        ...(selectedRecord.sendTo?.claimant_names || []),
                        ...(selectedRecord.sendTo?.respondent_names || []),
                        ...(selectedRecord.sendTo?.arbitrator_names || []),
                      ]
                        .map((r) => r.name)
                        .join(", ") || "No recipients"}
                    </p>
                  </div>
                </div>
              )}

              {/* Remarks - Rich Text Editor Area */}
              <div>
                <label className="block text-sm font-semibold text-black mb-2">
                  Remarks
                </label>
                <div className="border-2 border-gray-300 rounded-lg overflow-hidden">
                  {/* Toolbar - Simplified */}
                  <div className="bg-gray-50 border-b border-gray-300 p-2 flex flex-wrap gap-1 items-center">
                    <button
                      className="p-2 hover:bg-gray-200 rounded text-gray-600"
                      title="Undo"
                    >
                      ↶
                    </button>
                    <button
                      className="p-2 hover:bg-gray-200 rounded text-gray-600"
                      title="Redo"
                    >
                      ↷
                    </button>
                    <div className="w-px h-6 bg-gray-300 mx-1"></div>
                    <button className="p-2 hover:bg-gray-200 rounded font-bold">
                      B
                    </button>
                    <button className="p-2 hover:bg-gray-200 rounded italic">
                      I
                    </button>
                    <button
                      className="p-2 hover:bg-gray-200 rounded text-gray-600"
                      title="Underline"
                    >
                      U
                    </button>
                    <div className="w-px h-6 bg-gray-300 mx-1"></div>
                    <button
                      className="p-2 hover:bg-gray-200 rounded text-gray-600"
                      title="Align Left"
                    >
                      ≡
                    </button>
                    <button
                      className="p-2 hover:bg-gray-200 rounded text-gray-600"
                      title="Align Center"
                    >
                      ≡
                    </button>
                    <button
                      className="p-2 hover:bg-gray-200 rounded text-gray-600"
                      title="Align Right"
                    >
                      ≡
                    </button>
                    <button
                      className="p-2 hover:bg-gray-200 rounded text-gray-600"
                      title="Align Justify"
                    >
                      ≡
                    </button>
                    <div className="w-px h-6 bg-gray-300 mx-1"></div>
                    <button
                      className="p-2 hover:bg-gray-200 rounded text-gray-600"
                      title="Bullet List"
                    >
                      •
                    </button>
                    <button
                      className="p-2 hover:bg-gray-200 rounded text-gray-600"
                      title="Number List"
                    >
                      1.
                    </button>
                  </div>
                  {/* Text Area */}
                  <textarea
                    value={formData.remarks}
                    onChange={(e) =>
                      setFormData({ ...formData, remarks: e.target.value })
                    }
                    className="w-full px-4 py-3 border-0 text-black bg-white min-h-[200px] resize-none focus:outline-none"
                    placeholder="Enter remarks here..."
                  />
                </div>
              </div>

              {/* Choose Documents Section */}
              <div>
                <label className="block text-sm font-semibold text-black mb-2">
                  Choose Documents (PDF only)
                </label>

                <div className="flex items-center gap-4 flex-wrap">
                  <label className="px-6 py-3 bg-blue-100 text-blue-600 rounded-lg font-semibold cursor-pointer hover:bg-blue-200 transition-colors">
                    Choose Files
                    <input
                      type="file"
                      multiple
                      accept=".pdf"
                      className="hidden"
                      onChange={(e) => {
                        const files = Array.from(e.target.files);

                        if (files.length > 10) {
                          alert("Maximum 10 files allowed");
                          return;
                        }

                        setSelectedFiles(files);
                      }}
                    />
                  </label>

                  {/* SHOW FILES */}
                  {selectedFiles.length > 0 ? (
                    <div className="text-sm text-gray-700">
                      {selectedFiles.length} file(s) selected:
                      <ul className="mt-1 list-disc list-inside">
                        {selectedFiles.map((file, index) => (
                          <li key={index}>{file.name}</li>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    <span className="text-gray-500 text-sm">
                      No file chosen
                    </span>
                  )}
                </div>

                <p className="text-red-500 text-xs mt-2 font-medium">
                  * You can only upload max 10 files of max 20 mb
                </p>
              </div>

              {/* Existing Attachments */}
              {selectedRecord &&
                selectedRecord.serve_Document &&
                selectedRecord.serve_Document.length > 0 && (
                  <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
                    <h3 className="text-sm font-semibold text-black mb-3">
                      Existing Attachments (
                      {selectedRecord.serve_Document.length})
                    </h3>
                    <div className="space-y-2">
                      {selectedRecord.serve_Document.map((file, index) => (
                        <a
                          key={index}
                          href={file}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center gap-2 text-blue-500 hover:text-blue-700 text-sm"
                        >
                          📄 Document {index + 1}
                        </a>
                      ))}
                    </div>
                  </div>
                )}

              {/* Action Buttons */}
              <div className="flex gap-4 justify-center pt-6 border-t border-gray-200">
                <button
                  onClick={handleServeCopy}
                  disabled={isSubmitting}
                  className="px-8 py-3 bg-[#001f4d] text-white rounded-lg font-semibold hover:bg-[#00142e] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                >
                  {isSubmitting ? (
                    <>
                      <span className="animate-spin">⏳</span>
                      {isAddMode ? "Adding..." : "Serving..."}
                    </>
                  ) : isAddMode ? (
                    "Add E-Filing"
                  ) : (
                    "Serve Copy"
                  )}
                </button>
                <button
                  onClick={() => setShowEditModal(false)}
                  disabled={isSubmitting}
                  className="px-8 py-3 bg-gray-400 text-white rounded-lg font-semibold hover:bg-gray-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Detail Modal - Show Filing History */}
      {showDetailModal && detailData && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg shadow-lg max-w-5xl w-full max-h-[90vh] overflow-y-auto">
            {/* Modal Header */}
            <div className="sticky top-0 bg-white border-b border-gray-200 p-6 flex justify-between items-center">
              <h1 className="text-2xl font-bold text-black">Filing History</h1>
              <button
                onClick={() => setShowDetailModal(false)}
                className="text-gray-600 hover:text-gray-800 text-2xl"
              >
                ✕
              </button>
            </div>

            {/* Tabs */}
            <div className="sticky top-16 bg-white border-b border-gray-200 px-6 pt-4">
              <div className="flex gap-6 overflow-x-auto">
                {[
                  "Commence",
                  "E-Filing",
                ].map((tab) => {
                 const tabCounts = {
  Commence:
    detailData?.commenceDetails ? 1 : 0,
  "E-Filing":
    detailData?.efiling ? 1 : 0,
};
                  //   Commence:
                  //     detailData?.commenceDetails?.history?.filter(
                  //       (h) => h.model === "commence",
                  //     ).length || 0,
                  //   "E-Filing":
                  //     detailData?.commenceDetails?.history?.filter(
                  //       (h) => h.model === "eFiling",
                  //     ).length || 0,
                    
                  // };

                  return (
                    <button
                      key={tab}
                      onClick={() => setActiveTab(tab)}
                      className={`pb-4 px-2 font-semibold text-sm whitespace-nowrap border-b-2 transition-all ${
                        activeTab === tab
                          ? "text-blue-600 border-blue-600"
                          : "text-gray-600 border-transparent hover:border-gray-300"
                      }`}
                    >
                      {tab} ({tabCounts[tab]})
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Tab Content - Table */}
            <div className="p-6">
              <div className="overflow-x-auto">
                <table className="w-full border-collapse">
                  <thead>
                    <tr className="bg-gray-100 border-b-2 border-gray-300">
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                        Created At
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                        Document Type
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                        Subject
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                        Filed By
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                        Documents
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {activeTab === "E-Filing" && (
  <>
    {detailData?.efiling ? (
      <tr className="border-b border-gray-200 hover:bg-gray-50">
        <td className="px-4 py-3 text-sm text-black">
          {new Date(detailData.efiling.created_at).toLocaleString("en-IN")}
        </td>
        <td className="px-4 py-3 text-sm text-black">
          {detailData.efiling.document_type?.replace(/`/g, "") || "-"}
        </td>
        <td className="px-4 py-3 text-sm text-black">
          {detailData.efiling.subject?.replace(/`/g, "") || "-"}
        </td>
        <td className="px-4 py-3 text-sm text-black">
          {detailData.efiling.user?.first_name}{" "}
          {detailData.efiling.user?.last_name}
        </td>
        <td className="px-4 py-3 text-sm">
          {detailData.efiling.serve_Document?.map((doc, i) => (
            <a
              key={i}
              href={doc}
              target="_blank"
              rel="noopener noreferrer"
              className="px-3 py-1 border border-blue-500 text-blue-600 rounded text-xs"
            >
              Download {i + 1}
            </a>
          ))}
        </td>
      </tr>
    ) : (
      <tr>
        <td colSpan="5" className="text-center py-6">
          No E-Filing records found
        </td>
      </tr>
    )}
  </>
)}

                    {activeTab === "Commence" &&
                      detailData?.commenceDetails && (
                        <tr className="border-b border-gray-200 hover:bg-gray-50">
                          <td className="px-4 py-3 text-sm text-black">
                            {detailData?.commenceDetails?.created_at
                              ? new Date(
                                  detailData.commenceDetails.created_at,
                                ).toLocaleString("en-IN")
                              : "-"}
                          </td>
                          <td className="px-4 py-3 text-sm text-black">-</td>
                          <td className="px-4 py-3 text-sm text-black">
                            {detailData?.commenceDetails?.nature_of_Despute ||
                              "-"}
                          </td>
                          <td className="px-4 py-3 text-sm text-black">
                            {detailData?.efiling?.user?.first_name}{" "}
                            {detailData?.efiling?.user?.last_name}
                          </td>
                          <td className="px-4 py-3 text-sm">
                            {detailData?.commenceDetails?.arbitration_petition
                              ?.length > 0 ? (
                              <div className="flex flex-wrap gap-2">
                                {detailData.commenceDetails.arbitration_petition.map(
                                  (doc, idx) => (
                                    <a
                                      key={idx}
                                      href={doc}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="px-3 py-1 border border-blue-500 text-blue-600 rounded text-xs font-medium hover:bg-blue-50 transition-colors"
                                    >
                                      Download {idx + 1}
                                    </a>
                                  ),
                                )}
                              </div>
                            ) : (
                              <span className="text-gray-400 text-xs">
                                No documents
                              </span>
                            )}
                          </td>
                        </tr>
                      )}

                    {/* {["Schedule Arbitration", "Recording", "Orders"].includes(
                      activeTab,
                    ) && (
                      <tr>
                        <td
                          colSpan="5"
                          className="px-4 py-8 text-center text-gray-500"
                        >
                          No {activeTab} records found
                        </td>
                      </tr>
                    )} */}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Close Button */}
            <div className="p-6 border-t border-gray-200 flex justify-end">
              <button
                onClick={() => setShowDetailModal(false)}
                className="px-8 py-3 bg-gray-500 text-white rounded-lg font-semibold hover:bg-gray-600 transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Efiling;
